import {
  updateThesaurusType,
  selectThesaurusGroupByIdType,
  updateThesaurusGroupByIdType,
  syncThesaurusItemsWithGrouopsType,
  clearAllSelectedItemsInThesaurusType,
} from '../ListOfFiltersConstants';

export function updateThesaurus(key, filterId, rootGroupId, children) {
  return {
    type: updateThesaurusType,
    payload: {
      key,
      rootGroupId,
      filterId,
      children,
    },
  };
}

export function updateThesaurusGroupById(key, filterId, rootGroupId, data) {
  return {
    type: updateThesaurusGroupByIdType,
    payload: {
      key,
      rootGroupId,
      filterId,
      data,
    },
  };
}

export function selectThesaurusGroupById(key, filterId, groupId) {
  return {
    type: selectThesaurusGroupByIdType,
    payload: {
      key,
      groupId,
      filterId,
    },
  };
}

export function syncThesaurusItemsWithGrouops(key, filterId) {
  return {
    type: syncThesaurusItemsWithGrouopsType,
    payload: {
      key,
      filterId,
    },
  };
}

export function clearAllSelectedItemsInThesaurus(key, filterId) {
  return {
    type: clearAllSelectedItemsInThesaurusType,
    payload: {
      key,
      filterId,
    },
  };
}
